// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakeRequestModel {
    static getAttributeTypeMap() {
        return SimpleIntakeRequestModel.attributeTypeMap;
    }
}
SimpleIntakeRequestModel.discriminator = undefined;
SimpleIntakeRequestModel.additionalProperties = false;
SimpleIntakeRequestModel.attributeTypeMap = [
    {
        "name": "assignmentOfBenefits",
        "baseName": "assignmentOfBenefits",
        "type": "boolean"
    },
    {
        "name": "autoReenroll",
        "baseName": "autoReenroll",
        "type": "boolean"
    },
    {
        "name": "contacts",
        "baseName": "contacts",
        "type": "Array<SimpleIntakeAccountContactModel>"
    },
    {
        "name": "diagnosis",
        "baseName": "diagnosis",
        "type": "SimpleIntakeDiagnosisModel"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "SimpleIntakePatientModel"
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": "SimpleIntakePayorsModel"
    },
    {
        "name": "pharmacies",
        "baseName": "pharmacies",
        "type": "Array<SimpleIntakePharmacyModel>"
    },
    {
        "name": "prescribers",
        "baseName": "prescribers",
        "type": "Array<SimpleIntakePrescriberModel>"
    },
    {
        "name": "prescriptions",
        "baseName": "prescriptions",
        "type": "Array<SimpleIntakePrescriptionModel>"
    },
    {
        "name": "sites",
        "baseName": "sites",
        "type": "Array<SimpleIntakeSiteModel>"
    },
    {
        "name": "sourceId",
        "baseName": "sourceId",
        "type": "number"
    },
    {
        "name": "surveys",
        "baseName": "surveys",
        "type": "Array<SimpleIntakeSurveyModel>"
    },
    {
        "name": "thirdPartyId",
        "baseName": "thirdPartyId",
        "type": "string"
    },
    {
        "name": "workflows",
        "baseName": "workflows",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=simpleIntakeRequestModel.js.map